// extracted by mini-css-extract-plugin
export default {"textContainer":"TextAnimation_textContainer__kj3hh"};